import Store from "../../../../../../Store";
import lt from "./images/lt.jpg";
import cs from "./images/cs.jpg";

export const mockImages = {
  lt,
  cs
};

export const getMockImage = () => {
  const short = Store.getUserPlatformLangShort();
  return mockImages[short];
};
